import Button from 'app/components/UI-Elements/General/Button'
import { ToolBox } from 'app/lib/hooks/toolBox'
import RouteService from 'app/lib/services/RouteService'
import React, { ComponentProps } from 'react'

const HomePageButton: React.FC<Partial<ComponentProps<typeof Button>>> = (props) => {
  const { tButtonTitle } = ToolBox.useString()

  const goToWebsite = () => {
    window.location.href = `${RouteService.getKlarxHomePageUrl()}/mieten`
  }

  return (
    <Button
      onClick={goToWebsite}
      type={'primary'}
      title={tButtonTitle({ recordType: 'default', action: 'to_website' })}
      {...props}
    />
  )
}

export default HomePageButton
